import React from 'react';
import Delete from './DeleteData';

const InternationalDeleteData = props => <Delete {...props} international />;

export default InternationalDeleteData;
